module.exports = __webpack_public_path__ + "img/Drop Down Menu - Pink - Selected.599fefe2.png";